var ChangedMatchesModifier = /** @class */ (function () {
    function ChangedMatchesModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    ChangedMatchesModifier.prototype.modify = function (content) {
        if (content.events === undefined || content.events.change === undefined) {
            return;
        }
        var matches = content.events.change;
        for (var i = 0; i < matches.length; i++) {
            var match = matches[i];
            var key = this._modelKeyRepository.getMatchKey(match.id);
            matches[i] = Object.assign({
                name: match.n,
                notice: match.ntc,
                matchType: match.mt
            }, key);
        }
    };
    return ChangedMatchesModifier;
}());
export default ChangedMatchesModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/ChangedMatchesModifier.js